export enum HabitTargetType {
  BOOLEAN = 'Boolean',
  QUANTITY = 'Quantity',
  RATING = 'Rating',
}

export enum TargetEvaluation {
  DAILY = 'Daily',
  FINAL = 'Final',
}

export const TargetEvaluationLabels = {
  [TargetEvaluation.DAILY]: 'Daily target',
  [TargetEvaluation.FINAL]: 'Final target',
};

export enum TargetDirection {
  GROWTH = 'Growth',
  REDUCTION = 'Reduction',
}

export const TargetDirectionLabels = {
  [TargetDirection.GROWTH]: 'Growth target',
  [TargetDirection.REDUCTION]: 'Reduction target',
};

export interface HabitTarget {
  type: HabitTargetType;
  evaluation: TargetEvaluation;
  direction: TargetDirection;
  value: number;
}

export enum HabitFrequencyType {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  WEEK_DAYS = 'WeekDays',
  MONTH_DAYS = 'MonthDays',
  SPECIAL_DAYS = 'SpecialDays',
}

export const HabitFrequencyTypeLabels = {
  [HabitFrequencyType.DAILY]: 'Daily',
  [HabitFrequencyType.WEEKLY]: 'Weekly',
  [HabitFrequencyType.MONTHLY]: 'Monthly',
  [HabitFrequencyType.WEEK_DAYS]: 'Week days',
  [HabitFrequencyType.MONTH_DAYS]: 'Month days',
  [HabitFrequencyType.SPECIAL_DAYS]: 'Special days',
};

export enum WeekDay {
  MONDAY = 'Mo',
  TUESDAY = 'Tu',
  WEDNESDAY = 'We',
  THURSDAY = 'Th',
  FRIDAY = 'Fr',
  SATURDAY = 'Sa',
  SUNDAY = 'Su',
}

export enum SpecialDays {
  EMBER = 'Ember',
  HEART_JESUS_FRIDAY = 'HeartJesusFriday',
  HEART_MARY_SATURDAY = 'HeartMarySaturday',
}

export const SpecialDaysLabels = {
  [SpecialDays.EMBER]: 'Ember days',
  [SpecialDays.HEART_JESUS_FRIDAY]: 'First Friday Devotion',
  [SpecialDays.HEART_MARY_SATURDAY]: 'Heart of Mary Saturday of Atonement',
};
